/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/importable_external_bank_account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListImportableExternalBankAccountsRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "limit": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 10
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListImportableExternalBankAccountsResponse": {
                    "fields": {
                      "importableAccounts": {
                        "type": ".squareup.sfs.external.models.ImportableExternalBankAccount",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListImportableExternalBankAccountsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListImportableExternalBankAccountsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListImportableExternalBankAccountsRequest @ squareup/sfs/external/services/external_bank_account/list_importable_external_bank_accounts.proto at 9:1
 */
export const ListImportableExternalBankAccountsRequest = $root.lookupType('squareup.sfs.external.service.ListImportableExternalBankAccountsRequest');
fixType(ListImportableExternalBankAccountsRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(ListImportableExternalBankAccountsRequest);
/**
 * SOURCE ListImportableExternalBankAccountsResponse @ squareup/sfs/external/services/external_bank_account/list_importable_external_bank_accounts.proto at 30:1
 */
export const ListImportableExternalBankAccountsResponse = $root.lookupType('squareup.sfs.external.service.ListImportableExternalBankAccountsResponse');
fixType(ListImportableExternalBankAccountsResponse);
Builder.createAndAttachToType(ListImportableExternalBankAccountsResponse);